import { Button, Dialog, Text } from 'braid-design-system';
import { useId, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { defaultValues } from '../contactForm.tsx';
import type { FormValues } from '../types.ts';

import { useLocalStorage } from '#src/hooks/storage.ts';

export const ClearForm = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        tone="critical"
        onClick={() => {
          setOpen(true);
        }}
      >
        Clear
      </Button>
      <ClearFormConfirmation open={open} setOpen={setOpen} />
    </>
  );
};

interface ClearFormConfirmationProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const ClearFormConfirmation = ({
  open,
  setOpen,
}: ClearFormConfirmationProps) => {
  const { reset } = useFormContext<FormValues>();
  const [, setLocalFormValues] = useLocalStorage<FormValues | null>(
    '/seek-developer/contact-form',
    null,
  );

  return (
    <Dialog
      width="xsmall"
      id={useId()}
      title="Clear"
      open={open}
      onClose={() => setOpen(false)}
    >
      <Text>Are you sure you want to clear the form?</Text>
      <Button
        onClick={() => {
          reset(defaultValues);
          setLocalFormValues(null);
          setOpen(false);
        }}
        tone="critical"
      >
        Clear
      </Button>
    </Dialog>
  );
};
